import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React, { useEffect } from 'react';

export default function Modal({
  open,
  onClose,
  header,
  children,
  size = 'default',
}) {
  useEffect(() => {
    if (!open) {
      return undefined;
    }
    const html = document.documentElement;
    const prevHtmlOverflow = html.style.overflow;
    const prevBodyOverflow = document.body.style.overflow;
    html.classList.add('bethere-modal-open');
    html.style.overflow = 'hidden';
    document.body.style.overflow = 'hidden';

    return () => {
      html.classList.remove('bethere-modal-open');
      html.style.overflow = prevHtmlOverflow;
      document.body.style.overflow = prevBodyOverflow;
    };
  }, [open]);

  if (!open) {
    return null;
  }

  const panelWidth =
    size === 'sm'
      ? 'w-[min(28rem,calc(100vw-2rem))]'
      : 'w-[min(1024px,calc(100vw-2rem))]';

  return (
    <div>
      <div
        className="bethere-modal-overlay fixed inset-0 bg-black/40"
        onClick={() => onClose()}
        role="presentation"
      />
      <div
        className={`bethere-modal-panel fixed left-1/2 top-[4%] flex max-h-[min(92vh,960px)] ${panelWidth} -translate-x-1/2 flex-col overflow-hidden rounded-[var(--bethere-radius-lg)] bg-white shadow-xl`}
        role="dialog"
        aria-modal="true"
      >
        <header className="shrink-0 border-b border-black/[0.08] px-6 pb-4 pt-5 sm:px-8">
          <h3 className="flex min-h-[52px] items-center justify-between gap-4 text-xl font-bold text-[var(--muted-foreground)]">
            <span>{header}</span>
            <button
              type="button"
              className="m-0 shrink-0 cursor-pointer border-none bg-transparent p-0 text-[inherit] transition-colors hover:text-neutral-600"
              onClick={() => onClose()}
              aria-label="Close modal"
            >
              <FontAwesomeIcon icon={['fas', 'times-circle']} />
            </button>
          </h3>
        </header>
        <div
          className="bethere-modal-body min-h-0 flex-1 overflow-y-auto overscroll-contain px-6 py-6 sm:px-8"
          data-modal-scroll
        >
          {children}
        </div>
      </div>
    </div>
  );
}
